import { ECommerce } from "@omni/components/components/Product/ECommerce/eCommerce";
import { useECommerceProduct } from "@omni/components/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { StickyAction } from "@omni/components/components/StickyAction/stickyAction";
import { StickyActionElement } from "@omni/types/components/general/enums/stickyActionElement.enum";
import { Breakpoint } from "@omni/types/enums/breakPoint.enum";
import { cn } from "@omni/utils/styles";

import { DriveIn } from "@/components/Product/ECommerce/components/driveIn/driveIn.container";

import { Delivery } from "./components/delivery/delivery.container";
import { Pricing } from "./components/pricing/pricing.container";
import { TieredPrices } from "./components/tieredPrices/tieredPrices.container";

const EcommerceComponent = () => {
    const { isBoxArticle, isAdditionalService } = useECommerceProduct();

    return (
        <>
            <ECommerce.StorPickers.Info />
            <ECommerce.StorPickers.Select />
            <ECommerce.OrderButton>
                <StickyAction
                    stickyActionElement={StickyActionElement.AddToCartButton}
                    hiddenBreakpoint={Breakpoint.md}
                >
                    <ECommerce.OrderButton.Button
                        color={"primary"}
                        fullWidth={true}
                    />
                </StickyAction>
            </ECommerce.OrderButton>
            <div className={cn("tw:mb-8 tw:flex tw:flex-col tw:gap-4")}>
                <ECommerce.SoldOutStamp />
                <Pricing />
                <ECommerce.Variants />
                <TieredPrices />
                <Delivery />
                <div className={cn("tw:flex tw:justify-between")}>
                    {!isAdditionalService && (
                        <div className={cn("tw:flex tw:items-center")}>
                            {!isBoxArticle && <ECommerce.Compare />}
                        </div>
                    )}
                    <ECommerce.WishlistButton />
                </div>
            </div>
            <DriveIn className={cn("tw:mb-4")} />
        </>
    );
};

export { EcommerceComponent };
